import {getAuditById,getAudits,getAuditsByStatus,getAuditTypes,createAudit,updateAudit,removeAudit,getAuditsCalendarEvents,syncAudits,getArchives} from '../api/audit';
import moment from 'moment';

import {getErrors} from '../utils/tools';

import 'moment/locale/fr';
moment.locale('fr');

export function auditIsArchive(audit){
    if( (audit.status === "valid" || audit.status === "reject" ) && audit.invoices && audit.invoices.length > 0){
        return true;
    }else{
        return false;
    }
}

export function getAuditByIdAction(id,audits) {
  return(dispatch)=>{
    /*/!* Vérifie is l'audit existe dans le state *!/
    let exist = false
    for (var i in audits) {
      if(parseInt(id, 10) === parseInt(audits[i].id, 10)) {
        exist = true
        dispatch({
            type:"UPDATE_AUDIT",
            audit:audits[i]
        });
        return Promise.resolve("ok");
      }
    }

    if (!exist){*/
      dispatch({
          type:"UPDATE_LOADING",
          loading:true
      });
      return this.loggedIn().then((res) => { // Vérifie l'authentification
        const token = localStorage.getItem("id_token")
        return getAuditById(token,id)
          .then(res => {
              if(auditIsArchive(res)){
                  dispatch({
                      type:"UPDATE_ARCHIVE",
                      archive:res
                  });
              }else{
                  dispatch({
                      type:"UPDATE_AUDIT",
                      audit:res
                  });
              }
              dispatch({
                  type:"UPDATE_LOADING",
                  loading:false
              });

          })
          .catch((err)=>{
            let errors = getErrors(err)
            this.displaySnackbar("error", errors[0].message);
            throw err
          })
      })
    //}
  }
}

export function getAuditsAction() {
  return(dispatch)=>{
    return this.loggedIn().then((res) => { // Vérifie l'authentification
      const token = localStorage.getItem("id_token")
      return getAudits(token)
        .then(res => {
          dispatch({
              type:"UPDATE_AUDITS",
              audits:res
          });
        })
        .catch((err)=>{
          let errors = getErrors(err)
          this.displaySnackbar("error", errors[0].message);
          throw err
        })
    })
  }
}

export function getArchivesAction() {
    return(dispatch)=>{
        return this.loggedIn().then((res) => { // Vérifie l'authentification
            const token = localStorage.getItem("id_token")
            return getArchives(token)
                .then(res => {
                    dispatch({
                        type:"UPDATE_ARCHIVES",
                        archives:res
                    });
                })
                .catch((err)=>{
                    let errors = getErrors(err)
                    this.displaySnackbar("error", errors[0].message);
                    throw err
                })
        })
    }
}

export function getAuditsCalendarEventsAction() {
    return(dispatch)=>{
        return this.loggedIn().then((res) => { // Vérifie l'authentification
            const token = localStorage.getItem("id_token")
            return getAuditsCalendarEvents(token)
                .then(res => {
                    dispatch({
                        type:"UPDATE_CALENDAR_EVENTS",
                        events:res
                    });
                    return res;
                })
                .catch((err)=>{
                    let errors = getErrors(err)
                    this.displaySnackbar("error", errors[0].message);
                    throw err
                })
        })
    }
}

export function getAuditsByStatusAction(status) {
  return(dispatch)=>{
    return this.loggedIn().then((res) => { // Vérifie l'authentification
      const token = localStorage.getItem("id_token")
      return getAuditsByStatus(token, status)
        .then(res => {
          dispatch({
              type:"UPDATE_AUDITS_"+status,
              audits:res
          });
        })
        .catch((err)=>{
          let errors = getErrors(err)
          this.displaySnackbar("error", errors[0].message);
          throw err
        })
    })
  }
}

export function getAuditTypesAction() {
  return(dispatch)=>{
    return this.loggedIn().then((res) => { // Vérifie l'authentification
      const token = localStorage.getItem("id_token")
      return getAuditTypes(token)
        .then(res => {
          dispatch({
              type:"UPDATE_AUDITTYPES",
              listOfAuditTypes:res
          });
        })
        .catch((err)=>{
          let errors = getErrors(err)
          this.displaySnackbar("error", errors[0].message);
          throw err
        })
    })
  }
}

/*
  Enregistre un nouvel audit
*/
export function createAuditAction(data) {
  return(dispatch)=>{
    return this.loggedIn().then((res) => { // Vérifie l'authentification
      const token = localStorage.getItem("id_token")
      return createAudit(token, data)
        .then(res => {
            dispatch({
                type:"ADD_AUDIT",
                audit:res
            });
          this.displaySnackbar("success", "Audit enregistré");
          return res
        })
        .catch(async (err)=>{
            let errors = await getErrors(err)
            this.displaySnackbar("error", errors[0].message);
            throw err
        })
    })
  }
}

/*
  Met à jour un audit
*/
export function updateAuditAction(id, data) {
  return(dispatch)=>{
    return this.loggedIn().then((res) => { // Vérifie l'authentification
      const token = localStorage.getItem("id_token")
      return updateAudit(token, id, data)
        .then(res => {
            res.date = moment(data.date).format()
            if(auditIsArchive(res)){
                dispatch({
                    type:"UPDATE_ARCHIVE",
                    archive:res
                });
            }else{
                dispatch({
                    type:"UPDATE_AUDIT",
                    audit:res
                });
            }
          this.displaySnackbar("success", "Audit modifié");
          return res
        })
          .catch(async (err)=>{
              let errors = await getErrors(err)
              this.displaySnackbar("error", errors[0].message);
              throw err
          })
    })
  }
}

/*
  Synchronise la date avec l'agenda
*/
export function syncAuditsAction(ids) {
    return(dispatch)=>{
        return this.loggedIn().then((res) => { // Vérifie l'authentification
            const token = localStorage.getItem("id_token")
            return syncAudits(token, ids)
                .then(res => {
                    this.displaySnackbar("success", "Audit(s) synchronisé");
                    return res
                })
                .catch(async (err)=>{
                    let errors = await getErrors(err)
                    this.displaySnackbar("error", errors[0].message);
                    throw err
                })
        })
    }
}

/*
  Supprimer un audit
*/
export function removeAuditAction(id, data) {
  return(dispatch)=>{
    return this.loggedIn().then((res) => { // Vérifie l'authentification
      const token = localStorage.getItem("id_token")
      return removeAudit(token, id)
        .then(res => {
            if(auditIsArchive(res)){
                dispatch({
                    type:"REMOVE_ARCHIVE",
                    archive:id
                });
            }else{
                dispatch({
                    type:"REMOVE_AUDIT",
                    audit:id
                });
            }
          this.displaySnackbar("success", "Audit supprimé");
          return res
        })
          .catch(async (err)=>{
              let errors = await getErrors(err)
              this.displaySnackbar("error", errors[0].message);
              throw err
          })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/audit.js